import { PostalCodeMapper } from '../../../domains/locations/PostalCodes/PostalCodeMapper.js';
import { CountryMapper } from '../../../domains/locations/Countries/CountryMapper.js';
import { Place } from '../../../models/Place/Place.js';

class Places {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(params) {
    const apiParams = {
      language: params.language,
      origin_city: params.originCity,
      origin_zipcode: params.originZipcode,
      origin_country: params.originCountry,
      destination_city: params.destinationCity,
      destination_zipcode: params.destinationZipcode,
      destination_country: params.destinationCountry
    };
    return this.apiClient.get('com/places', apiParams).then(_ref => {
      let {
        data
      } = _ref;
      const {
        origin,
        destination
      } = data;
      const originPostalCode = PostalCodeMapper.createModelFromResponse(origin.postal_code);
      const parsedOriginCountry = {
        ...origin.country,
        alpha2Code: origin.country.alpha_2_code
      };
      const originCountry = CountryMapper.createModelFromResponse(parsedOriginCountry);
      const destinationPostalCode = PostalCodeMapper.createModelFromResponse(destination.postal_code);
      const parsedDestinationCountry = {
        ...destination.country,
        alpha2Code: destination.country.alpha_2_code
      };
      const destinationCountry = CountryMapper.createModelFromResponse(parsedDestinationCountry);
      return {
        origin: new Place(originCountry.alpha2Code, originPostalCode.city, originCountry.name, originPostalCode.zipCode),
        destination: new Place(destinationCountry.alpha2Code, destinationPostalCode.city, destinationCountry.name, destinationPostalCode.zipCode)
      };
    });
  }
}

export { Places };
//# sourceMappingURL=Places.js.map
